import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import * as api from '../../api/departmentApi';
const mk = (name, fn) => createAsyncThunk(name, async (a, { rejectWithValue }) => {
  try { return (await fn(a)).data.data; } catch (e) { return rejectWithValue(e.response?.data?.message || 'Error'); }
});
export const fetchDepartments  = mk('depts/fetchAll', () => api.getDepartments());
export const createDepartment  = mk('depts/create',   dto => api.createDepartment(dto));
export const updateDepartment  = mk('depts/update',   ({id,dto}) => api.updateDepartment(id, dto));
export const deleteDepartment  = mk('depts/delete',   id => api.deleteDepartment(id));
const s = createSlice({ name: 'departments', initialState: { list: [], loading: false, error: null },
  reducers: {},
  extraReducers: b => {
    b.addCase(fetchDepartments.pending, s => { s.loading = true; })
     .addCase(fetchDepartments.fulfilled, (s,{payload}) => { s.loading = false; s.list = payload || []; })
     .addCase(fetchDepartments.rejected, (s,{payload}) => { s.loading = false; s.error = payload; });
    b.addCase(createDepartment.fulfilled, (s,{payload}) => { s.list.push(payload); });
    b.addCase(updateDepartment.fulfilled, (s,{payload}) => { const i=s.list.findIndex(d=>d.id===payload.id); if(i>=0) s.list[i]=payload; });
    b.addCase(deleteDepartment.fulfilled, (s,{meta}) => { s.list = s.list.filter(d=>d.id!==meta.arg); });
  }
});
export default s.reducer;
